/*!
 * Start and stop scheduler
 */
document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('[data-scheduler-start][data-scheduler-end]')
    .forEach(el => {
      const from = Date.parse(el.dataset.schedulerStart);
      const to   = Date.parse(el.dataset.schedulerEnd);
      const now  = Date.now();
      if (isNaN(from) || isNaN(to)) return;   // invalid or missing

      const isVisible = (from <= now && now < to);
      el.classList.toggle('hidden', !isVisible);
      el.setAttribute('aria-hidden', String(!isVisible));
    });
});

/*!
 * Open all external links in a new tab
 */
document.querySelectorAll('a[href]').forEach(link => {
    if (link.href.startsWith('mailto:') || link.href.startsWith('tel:') || link.hash) {
        return;
    }

    const url = new URL(link.href, window.location.origin);

    if (url.hostname !== window.location.hostname) {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
    }
});